export default __webpack_public_path__ + "static/media/default_tool_picture.59eedff6.png";